/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

import {
    getSelectedObjectsProperty,
  } from './../utils/common';
  
  // Template for the Dropdown
  const selectPracticesTemplate = `
  <div uib-dropdown class="filters-action">
    <style>
      .select-practice-areas .dropdown-toggle,
      .select-practice-areas .dropdown-toggle:hover,
      .select-practice-areas .dropdown-toggle:active,
      .select-practice-areas .dropdown-button.dropdown-toggle:focus {
        border: none;
      }
      .dropdown-button{
        color: #242633;
        padding: 8px 10px;
        width: 100%;
        font-size: 14px;
        font-weight: inherit;
        letter-spacing: normal;
        text-transform: unset;
        border-color: transparent;
        text-align: left;
      }
      .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {
        background-color: transparent;
        color: #242633;
      }
      .dropdown .bootstrapDropdown{
        max-height: 300px;
        width: 383px;
        // z-index: 1;
      }
      .practiceAreasDropdownAgGrid{
        width: 450px !important;
        max-height: 450px !important;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      }
      .practice-area-list {
        padding-left: 70px;
      }
      .practice-area-list li{
        padding: 3px 0;
      }

      .practiceAreasPadding {
        padding-left: 2px;
      }
      .resetSelectAllButton {
        position: absolute;
        background: white;
        z-index: 1;
        padding-bottom: 15px;
        text-align: right;
      }
      .agGridTempReset:focus{
        border: 1px solid transparent !important;
        background-color: #95288f !important;
        border-color: #95288f !important;
      }
    </style>
    <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" data-tooltip-check={{data.iconlabel}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <style type="text/css">
          .st0{fill:#9D9D9D;}          
        </style>
            <path fill="none" d="M0 0h24v24H0V0z"/>
            <path class="st0" d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/></svg>
          
        </button>
  
    <div uib-dropdown-menu  class="bootstrapDropdown practiceAreasDropdownAgGrid">
    <div class="modal-row custom-modal">
      <div class="row resetSelectAllButton col-md-12">
        <button ng-click="resetPractices()" class="btn btn-info btn-xs agGridTempReset">Select All</button>
        <button ng-click="deselectPractices()" class="btn btn-info btn-xs agGridTempReset">Deselect All</button>
      </div>
      <div class="col-md-12 margin-t15">
      <br />
        <div ng-class="{'practiceAreasPadding': law_area.practices.length}" data-ng-repeat="law_area in data.nrefPractices">
          <span ng-class="{'no-child': law_area.practices.length === 0}">
            <i ng-hide="law_area.showSubPracticeAreas || law_area.practices.length === 0" ng-click="displaySubPracticeAreas(law_area)"
              class="fa fa-plus expand-collapse-button" aria-hidden="true"></i>
          </span>
          <span ng-class="{'no-child': law_area.practices.length === 0}">
            <i ng-hide="!law_area.showSubPracticeAreas" ng-click="hideSubPracticeAreas(law_area)" class="fa fa-minus expand-collapse-button"
              aria-hidden="true"></i>
          </span>
          <label class="ui-checkbox">
            <input type="checkbox" id="{{law_area.practice_name}}" ng-click="selectPractices($event , law_area , 2)" data="{{practice_ID}}" ng-checked="law_area.isSelected">
            <span class="checkbox-group-heading" ng-style="law_area.practices.length > 0 && {'font-weight': 'bold'}">{{law_area.practice_name}}
            </span>
          </label>
          <ul ng-show="law_area.showSubPracticeAreas" class=" practice-area-list clearfix">
            <li data-ng-repeat="practice in law_area.practices">
              <label class="ui-checkbox">
                <input type="checkbox" id="{{practice.practice_name}}" data="{{practice.loc_ID}}" ng-click="selectPractices($event , practice , 1)" ng-checked="practice.isSelected">
                <span>{{practice.practice_name}}</span>
              </label>
              <ul class=" sub-list clearfix">
                <li data-ng-repeat="sub in practice.sub_areas">
                  <label class="ui-checkbox">
                    <input type="checkbox" id="{{sub.practice_name}}" ng-click="selectPractices($event , sub , 0)" ng-checked="sub.isSelected">
                    <span>{{sub.practice_name}}</span>
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
      
  </div>
  `;
  
  // Controller for the dropdown directive
  const selectPracticesController = ($scope, $timeout, practicesService) => {
    const stopEventExecution = event => {
      event.stopPropagation();
    };
  
    $('.practiceAreasDropdownAgGrid').click(stopEventExecution);
  
    // Method to update the outside scope's practices model
    // model will be used outside the directive(inside parent's
    // controller)

    $scope.$on('ag-grid-reset-filters', function(evt){
      $scope.resetPractices();
    });

    $scope.displaySubPracticeAreas = function(law_area) {
      return law_area.showSubPracticeAreas = true;
    };
    $scope.hideSubPracticeAreas = function(law_area) {
      return law_area.showSubPracticeAreas = false;
    };
    const updatePracticesModel = (allowUpdate = true) => {
      const updateAndNotify = (values = []) => {
        $scope.pracsModel = values;
        $scope.data.onPracChange();
        $timeout(()=> $scope.$apply());
      };
  
      //If model is not provided just notify the parent
      // to update itself
      if (!$scope.hasOwnProperty('pracsModel') || !allowUpdate) {
        updateAndNotify([]);
        return;
      }
  
      //If model is provided, filter the ids of the selected
      // objects and notify parent
      getSelectedObjectsProperty(
        practicesService.linearize($scope.data.nrefPractices),
        'practice_ID'
      ).then(updateAndNotify);
  
    };
  
    // Resets the selection of all Practices
    $scope.resetPractices = () => {
      practicesService.clearSelection($scope.data.nrefPractices, $scope.data.selectOnReset);
      updatePracticesModel(false);
    };
    
    $scope.deselectPractices = () => {
      practicesService.deselectSelection($scope.data.nrefPractices, false);
      updatePracticesModel(false);
    };
  
    // Selects a particular practice
    $scope.selectPractices = (event, current, level) => {
      practicesService.select($scope.data.nrefPractices, event, current, level);
      updatePracticesModel();
    };
  };
  
  
  // returns DDO for the dropdown
  const practiceAreaDropdownAgGridTemp = () => {
    return {
      restrict: 'AE',
      scope: {
        pracsModel: '=?',
        data: '='
      },
      replace: true,
      template: selectPracticesTemplate,
      controller: selectPracticesController
    };
  };
  
  angular
  .module('app.directives')
  .directive('practiceAreaDropdownAgGridTemp', practiceAreaDropdownAgGridTemp);  


// WEBPACK FOOTER //
// ./scripts/shared/directives/practice-area-dropdown-ag-grid-temp.js